// @flow
import type { Permission } from '../modules/authorisation/Permissions';
import Permissions from '../modules/authorisation/Permissions';
import type { Role } from '../types/Data';

class RadioUser {

  permissions: Array<Permission>;
  roles: Array<Role>;
  canManage: boolean;
  isRegistered: boolean;
  email: string;
  surname: string;
  name: string;
  language: string;

  constructor(permissions: Array<Permission>, roles: Array<Role>, canManage: boolean, isRegistered: boolean, email: string, name: string, surname: string, language: string) {
    this.permissions = permissions;
    this.roles = roles;
    this.canManage = canManage;
    this.isRegistered = isRegistered;
    this.email = email;
    this.surname = surname;
    this.name = name;
    this.language = language;
  }

  isSameAs(user: RadioUser) {
    return this.email === user.getEmail();
  }

  hasPermission(permission: Permission): boolean {
    return this.permissions.includes(permission);
  }

  isAdministrator() {
    return this.hasRole('ADMINISTRATOR');
  }

  hasRole(roleReference: string): boolean {
    return this.roles.find(role => role.reference === roleReference) !== undefined;
  }

  isProduction(): boolean {
    return !this.hasPermission(Permissions.MANAGE_CAMPAIGNS) && this.hasPermission(Permissions.MANAGE_CAMPAIGNS_ADVERTISEMENT);
  }

  setRoles(roles: Array<Role>): void {
    this.roles = roles;
  }

  isManageable(): boolean {
    return this.canManage;
  }

  hasAcceptedInvitation(): boolean {
    return this.isRegistered;
  }

  getRoles(): Array<Role> {
    return this.roles;
  }

  getPermissions(): Array<Permission> {
    return this.permissions;
  }

  getEmail(): string {
    return this.email;
  }

  getFullName(): string {
    return this.name + ' ' + this.surname;
  }

  getName(): string {
    return this.name;
  }

  setEmail(email: string): void {
    this.email = email;
  }

  setUserProfile(data: Object): void {
    this.name = data.name;
    this.surname = data.surname;
    this.language = data.language;
  }

  toObject(): Object {
    return {
      permissions: this.permissions,
      roles: this.roles,
      canManage: this.canManage,
      pending: !this.isRegistered,
      email: this.email,
      name: this.name,
      surname: this.surname,
      language: this.language,
    };
  }

  static parse(data: Object): RadioUser {
    return new RadioUser(data.permissions, data.roles, data.canManage, !data.pending, data.email, data.name, data.surname, data.language);
  }
}


export default RadioUser;



// WEBPACK FOOTER //
// ./src/statsradio/domain/RadioUser.js